const axios = require('@/utils/axios')
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	cliparts : [],
	current_clipart : null,
}

const getters = {
	fetchCliparts : (state) => state.cliparts,
	fetchCurrentClipart : (state) => state.current_clipart,
}

const actions = {
	loadCliparts({commit}, {token}){
		return $http.get(`clipart`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_CLIPARTS', response.data)
		})
	},

	loadCurrentClipart({commit}, {id, token}){
		return $http.get(`clipart/${id}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_CURRENT_CLIPART', response.data)
		})
	},

	createClipart({commit}, {clipart, token}){
		let clipart_formdata = new FormData()
		for(let key in clipart){
			clipart_formdata.append(key, clipart[key])
		}
		
		return $http.post('clipart', clipart_formdata, {
			headers : {
				'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('ADD_CLIPART', response.data)
		})
	},

	updateClipart({commit}, {id, clipart, token}){
		let clipart_formdata = new FormData()
		for(let key in clipart){
			if(key == 'editfile'){
				clipart_formdata.append(key, JSON.stringify(clipart[key]))
			}else{
				clipart_formdata.append(key, clipart[key])
			}	
		}
		
		return $http.put(`clipart/${id}`, clipart_formdata, {
			headers : {
				'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('UPDATE_CLIPART', response.data)
		})
	},

	deleteClipart({commit}, {id, token}){
		return $http.delete(`clipart/${id}`, {
			headers : {
				'x-auth-token' : token
			} 
		}).then((response) => {
			if(response.data.n > 0){
				commit('REMOVE_CLIPART', id)	
			}
		})
	},
}

const mutations = {
	SET_CLIPARTS : (state, cliparts) => {
		state.cliparts = cliparts
	},
	SET_CURRENT_CLIPART : (state, clipart) => {
		state.current_clipart = clipart
	},
	ADD_CLIPART : (state, clipart) => {
		state.cliparts.push(clipart)
	},
	UPDATE_CLIPART : (state, clipart) => {
		state.current_clipart = clipart
	},
	REMOVE_CLIPART : (state, clipart_id) => {
		const clipart_index = state.cliparts.map((clipart) => clipart._id).indexOf(clipart_id)
		state.cliparts.splice(clipart_index, 1)
	},
}

export default {
	state, getters, actions, mutations
}